module.exports = __webpack_public_path__ + "card.a6b08e4b176b9c6e25ff6f23e8f70915.png";